import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customeropinion',
  templateUrl: './customeropinion.component.html',
  styleUrls: ['./customeropinion.component.scss']
})
export class CustomeropinionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
